import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ListViewBorderedGlyph = /*#__PURE__*/createElement("g", {
  id: "list_view_bordered"
}, /*#__PURE__*/createElement("rect", {
  x: "28.5",
  y: "27.5",
  className: "st9",
  width: "3.4",
  height: "3.4"
}), /*#__PURE__*/createElement("rect", {
  x: "28.5",
  y: "35.5",
  className: "st9",
  width: "3.4",
  height: "3.4"
}), /*#__PURE__*/createElement("rect", {
  x: "28.5",
  y: "43.5",
  className: "st9",
  width: "3.4",
  height: "3.4"
}), /*#__PURE__*/createElement("path", {
  className: "st9",
  d: "M37.1,27.5h16.3c0.9,0,1.6,0.8,1.6,1.7c0,0.9-0.7,1.7-1.6,1.7H37.1c-0.9,0-1.6-0.8-1.6-1.7 C35.5,28.3,36.2,27.5,37.1,27.5z"
}), /*#__PURE__*/createElement("path", {
  className: "st9",
  d: "M37.1,35.5h16.3c0.9,0,1.6,0.8,1.6,1.7c0,0.9-0.7,1.7-1.6,1.7H37.1c-0.9,0-1.6-0.8-1.6-1.7 C35.5,36.3,36.2,35.5,37.1,35.5z"
}), /*#__PURE__*/createElement("path", {
  className: "st9",
  d: "M37.1,43.5h6.3c0.9,0,1.6,0.8,1.6,1.7c0,0.9-0.7,1.7-1.6,1.7h-6.3c-0.9,0-1.6-0.8-1.6-1.7 C35.5,44.3,36.2,43.5,37.1,43.5z"
}), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M63.5,68.6h-44V15.5h44V68.6z M22.5,65.6h38V18.5h-38V65.6z"
})));
const ListViewBordered = createSvg({
  name: 'list_view_bordered',
  path: ListViewBorderedGlyph
});

export default ListViewBordered;
export { ListViewBorderedGlyph };
